import { component } from 'picoapp'

export default component((node) => {
    const toggles = node.querySelectorAll('[data-toggle]'),
        contents = node.querySelectorAll('[data-content]')

    toggles.forEach((ele, i) => {
        ele.addEventListener('click', () => {
            toggleTab(ele, contents[i])
        })
    })

    function toggleTab(element, tabContent) {
        element.classList.toggle('product__tab--active')

        const lazyVideos = tabContent.querySelectorAll('source[data-src]')
        lazyVideos.forEach((video) => {
            video.setAttribute('src', video.dataset.src)
            video.removeAttribute('data-src')
            video.parentNode.load()
            video.parentNode.play()
        })

        if (tabContent.style.maxHeight) {
            tabContent.style.maxHeight = null
            tabContent.setAttribute('aria-hidden', true)
        } else {
            tabContent.style.maxHeight = `${tabContent.scrollHeight}px`
            tabContent.setAttribute('aria-hidden', false)
        }
    }

    document.addEventListener('productTabAnchorClick', ({ detail }) => {
        const cleanHash = detail.hash.replace('#', '')
        const tab = node.querySelector(`[data-toggle="${cleanHash}"]`)

        if (!tab) return

        const stickyHeader = document.querySelector('[data-sticky-header]')
        const top = tab.offsetTop - stickyHeader.offsetHeight

        window.scrollTo({
            top,
            behavior: 'smooth',
        })

        const tabIndex = Array.from(toggles).findIndex((ele) => ele.getAttribute('data-toggle') === cleanHash)
        const tabToggle = toggles[tabIndex]
        const tabContent = contents[tabIndex]

        toggleTab(tabToggle, tabContent)
    })
})
